import React from 'react';
import {
  TbLayoutSidebarLeftCollapse,
  TbLayoutSidebarLeftExpand,
  TbX,
} from 'react-icons/tb';
import { useNavigate } from 'react-router-dom';
import icLogo from '../static/logo-light.svg';
import {
  wrap,
  overlay,
  top,
  logo,
  toggle,
  closeButton,
  contentsWrap,
} from './style';
import Menus from './Menus';
import Profile from './Profile';

interface Props {
  isDrawerOpen?: boolean;
  onCloseDrawer?: () => void;
}

function SideNav({ isDrawerOpen = false, onCloseDrawer }: Props) {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = React.useState(true);

  const handleToggle = React.useCallback(() => setIsOpen((prev) => !prev), []);

  return (
    <>
      <div css={overlay(isDrawerOpen)} onClick={onCloseDrawer} />
      <nav css={wrap(isOpen, isDrawerOpen)}>
        <div css={top(isOpen)}>
          <button
            type="button"
            css={logo(isOpen)}
            onClick={() => navigate('/')}
          >
            <img src={icLogo} alt="logo" />
          </button>
          <button
            type="button"
            css={toggle}
            onClick={handleToggle}
            aria-label={isOpen ? '사이드 메뉴 접기' : '사이드 메뉴 펼치기'}
          >
            {isOpen ? (
              <TbLayoutSidebarLeftCollapse size={20} />
            ) : (
              <TbLayoutSidebarLeftExpand size={20} />
            )}
          </button>
          <button
            type="button"
            css={closeButton}
            onClick={onCloseDrawer}
            aria-label="메뉴 닫기"
          >
            <TbX size={22} />
          </button>
        </div>
        <div css={contentsWrap}>
          <Menus isCollapsed={!isOpen} onExpand={() => setIsOpen(true)} />
        </div>
        <Profile isCollapsed={!isOpen} />
      </nav>
    </>
  );
}

export default SideNav;
